import axios from 'axios';
import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import constants from 'constants';
import actions from 'actions';

const {
  setQuizStatus,
  loadWebinarSaga,
} = actions;

const {
  CHECK_ANSWERS_SAGA,
  API_RESULTS
} = constants;

const apiCheckAnswers = (webinarId, answers) => (
  axios.put(`${API_RESULTS}/${webinarId}`, {
    answers: answers
  })
);

function* checkAnswers({ answers, webinarId }) {
    try {
      const response = yield call(apiCheckAnswers, webinarId, answers);
      yield put(setQuizStatus(`completed_${webinarId}`, response.data.quiz_result))
      yield put(loadWebinarSaga(webinarId));
    } catch (e) {
      yield put(setQuizStatus(`failed_${webinarId}`, e.response.data.quiz_result))
    }
}


function* __checkAnswersSaga() {
  yield takeLatest(CHECK_ANSWERS_SAGA, checkAnswers)
}

export {
  __checkAnswersSaga,
};



// WEBPACK FOOTER //
// ./src/sagas/quiz.js